import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import { Field } from 'redux-form';
import { Utils } from '../../services';
import { SectorsField } from '../../components';
import store from '../../redux';

/** Class representing a Sectors selector field. */
class SectorsSelectorField extends TextField {

    constructor(properties) {
        super({
            ...(SectorsSelectorField.getDefaultOptions()),
            ...properties,
            name: 'sectors'
        });

        this.type = FormLayout.SECTORS;

        // sort choices by ascending position
        this.choices = (this.choices || []).sort((a, b) => a.position - b.position);
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();
        Utils.langs().forEach(lang => { properties.label[lang] = "";  });

        properties.name     = 'sectors';
        properties.choices  = [];
        properties.expanded = false;
        properties.required = true;
        properties.multiple = true;

        return properties;
    }

    /**
     * Get choices refs, if any
     *
     * Refs are used to propose linked resources as choices,
     * like the sectors or abilities for example
     */
    getRefs() {
        const sectors = store?.getState()?.sectors?.sectors || [];
        return sectors?.map(sector => ({
            id: sector.id,
            name: sector.name,
        }));
    }

    /**
     * Get choices refs source, if any
     *
     * Refs are used to propose linked resources as choices,
     * like the sectors or abilities for example
     */
    getRefsSource() {
        return 'sectors';
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return [
            FormLayout.OPTION_WIDTH,
            FormLayout.OPTION_LABEL,
            FormLayout.OPTION_CHOICES,
        ];
    }

    /**
     * Return this field preview input
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        let sectors = props.resources?.sectors;
        if (!sectors?.length) {
            sectors = (store?.getState()?.sectors?.sectors || []);
        }
        const sector_ids = this.choices?.map(choice => choice.ref_id);
        sectors = sectors.filter(sector => sector_ids.includes(sector.id));

        return (
            <SectorsField
                sectors={sectors}
                name={this.id}
                preventSubmit
            />
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'location-arrow';
    }
}

export default SectorsSelectorField;
